var $b250f0dff34005b3$exports = {};
$b250f0dff34005b3$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cor`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};


export {$b250f0dff34005b3$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
